import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { STATS, CREDIBILITY } from "../../data/content";
import { Reveal } from "../Reveal";

function CountUp({ value, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-20% 0px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1800;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <span ref={ref}>
      {n}
      {suffix}
    </span>
  );
}

export default function Numbers() {
  return (
    <section className="relative overflow-hidden bg-navy-900 py-24 sm:py-32 md:py-40">
      <div className="mx-auto max-w-[1440px] px-6 sm:px-12">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="border-t border-gold/20 pt-6">
                <p className="font-heading text-6xl font-light text-gold sm:text-7xl">
                  <CountUp value={s.value} suffix={s.suffix} />
                </p>
                <p className="mt-4 text-sm uppercase tracking-[0.15em] text-offwhite">{s.label}</p>
                <p className="mt-1 text-xs text-offwhite/45">{s.sub}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-20 grid gap-8 border-t border-gold/20 pt-12 lg:grid-cols-[1fr_1.4fr] lg:gap-16">
            <div className="flex items-baseline gap-4">
              <span className="font-heading text-7xl font-light text-gold sm:text-8xl">
                <CountUp value={50} suffix="+" />
              </span>
              <span className="text-sm uppercase tracking-[0.2em] text-offwhite/70">
                sites pan-India
                <br />
                for PVR INOX
              </span>
            </div>
            <p className="max-w-xl self-center text-base font-light leading-relaxed text-offwhite/70">
              {CREDIBILITY}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
